const VALID_SEARCH_TYPES = ['region', 'postcode', 'place'];

export const validateSearchTypes = (type) => VALID_SEARCH_TYPES.includes(type);

export default validateSearchTypes;
